import { createFileRoute } from '@tanstack/react-router'
import { EparakstsEmailSignPage } from '@/pages/agreements/ui/EparakstsEmailSignPage'

export const Route = createFileRoute('/eparaksts/$code')({
  component: Page,
})

function Page() {
  const { code } = Route.useParams()
  return <EparakstsEmailSignPage code={code} />
}
